import { render, staticRenderFns } from "./SenQForm.vue?vue&type=template&id=59b57f1a&scoped=true&"
import script from "./SenQForm.vue?vue&type=script&lang=js&"
export * from "./SenQForm.vue?vue&type=script&lang=js&"
import style0 from "./SenQForm.vue?vue&type=style&index=0&id=59b57f1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b57f1a",
  null
  
)

export default component.exports